// src/components/Section1.js
import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  background-color: #000000;
  padding: 5% 6%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width:85%;
  margin:0 auto;

  @media (min-width: 500px) {
    padding: 5% 10% 5% 10%;
  }

`;

const CardContainer = styled.div`
  
  display: flex;
  flex-direction: column; 
  gap: 24px; 

  
  @media (min-width: 500px) {
    flex-direction: row; 
    gap: 20px; 
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  
  flex: 1;
  max-width: 100%;
  height: auto;
  padding: 36px;


  @media (max-width: 500px) {
    padding: 0%;
  }

`;

const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  color: #FFFFFF;
  margin-top:10px;
  margin-bottom:0px;

  span{
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 46px;
    margin-bottom:4px;
    text-align: center;
    margin:0 auto;
  }

`;



const Content = styled.p`
  color: #EFEFEF;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  margin-bottom:20px;

  li {
    position: relative;
    padding-left: 1.5em;
    margin-bottom: 8px;
    text-indent: -1.5em;
  }





  @media (max-width: 500px) {
    font-size: 14px;
    margin-bottom:16px;
    line-height: 24px;
    padding:5% 0% 5% 0%;
  }


`;









const RetroPGFSec2 = () => (
  <SectionWrapper>
    <CardContainer>
      <Card>
        <Title>回溯性公共資助<br/>是什麼？<span>.</span></Title>
        <Content>
          回溯性公共資助，是一種讓社會更容易評估公共財價值，根據其價值給予認購，鼓勵社群主動建設公共財，並獲得所需資金得以繼續營運下去的一種方式。<br/><br/>
          本研究的回溯性公共資助流程，希望開闢一個有利於打造數位公共財的環境，拓寬開源社群與政府協作建設數位公共財的空間。透過共同參與、建立信任、分散權力，來建立社會資本。這種管道所建立的社會資本，將普遍分散在所有參與者身上，而非集中在大企業或政府身上。而建設過程中所培育的做法，也能夠將社會團結經濟的文化注入到資訊科技產業中。          
        </Content>
   
        

      </Card>
      <Card>
        <Title>回溯性公共資助<br/>預期效益<span>.</span></Title>
        <Content>
          為達成台灣數位 SSE ，本團隊根據 IAD 行動框架定義次世代採購框架，其預期效果為：<br/><br/>
          <li>專案達成多少社會影響力，由該專案的使用者、貢獻者、組織者共同認定。衡量方式在專案內部具備正當性。社會影響力的衡量方式與需求的解決相對齊，免除社會影響力衡量標準未必完備，以及外部衡量組織成本昂貴的問題。</li>
          <li>以經濟誘因強化成員持續參與的動機，降低專案中斷的風險，以及難以要求成員認真貢獻的問題。</li>
          
        </Content>
    
        
        
        
      </Card>
    </CardContainer>
  </SectionWrapper>
);

export default RetroPGFSec2;
